// extracted by mini-css-extract-plugin
module.exports = {"link":"ContactLink_link__1y5_G","icon":"ContactLink_icon__V4VKS","water":"ContactLink_water__2yTYk","rotate":"ContactLink_rotate__VaWZN","pulsate":"ContactLink_pulsate__PhYzB"};